import { additionalPalette } from '@focaldata/cin-ui-components'
import { Outlet } from 'react-router-dom'

import { useFdChatContainerContent } from '../FdChat.hooks'

const FdChatResultsContainer = () => {
  const { contentRef } = useFdChatContainerContent()

  return (
    <div
      className="fd-chat-results-container"
      style={{
        backgroundColor: additionalPalette.lightBlue.main,
        minHeight: '100%'
      }}
    >
      <Outlet context={{ contentRef }} />
    </div>
  )
}

export default FdChatResultsContainer
